import { Action, Reducer } from "redux";
import {
	SupplierInventoryWarehouseStatusState,
	SupplierInventoryWarehouseStatusTypes,
	SupplierInventoryWarehouseStatusActionTypes,
} from "./supplierInventoryWarehouseStatusTypes";

export const INITIAL_STATE: SupplierInventoryWarehouseStatusState = {
	supplierInventoryWarehouseStatus: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const supplierInventoryWarehouseStatusReducer: Reducer<SupplierInventoryWarehouseStatusState> = (
	state: SupplierInventoryWarehouseStatusState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as SupplierInventoryWarehouseStatusActionTypes;
	switch (actionTypes.type) {
		case SupplierInventoryWarehouseStatusTypes.GET_SUPPLIER_INVENTORY_WAREHOUSE_STATUS:
			return {
				...state,
				supplierInventoryWarehouseStatus: {
					...state.supplierInventoryWarehouseStatus,
					isLoading: true,
				},
			};
		case SupplierInventoryWarehouseStatusTypes.SAVE_SUPPLIER_INVENTORY_WAREHOUSE_STATUS:
			return {
				...state,
				supplierInventoryWarehouseStatus: {
					...state.supplierInventoryWarehouseStatus,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case SupplierInventoryWarehouseStatusTypes.RESET_REDUCER_SUPPLIER_INVENTORY_WAREHOUSE_STATUS:
			return {
				...state,
				supplierInventoryWarehouseStatus: INITIAL_STATE.supplierInventoryWarehouseStatus,
			};
		default:
			return state;
	}
};

export default supplierInventoryWarehouseStatusReducer;
